import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'full_name',
        label: i18n.t('membership_request.full_name')
    },
    {
        key: 'mobile',
        label: i18n.t('membership_request.mobile')
    },
    {
        key: 'email',
        label: i18n.t('membership_request.email')
    },
    {
        key: 'site_name',
        label: i18n.t('membership_request.site_name')
    },
    {
        key: 'site',
        label: i18n.t('membership_request.site')
    },
    {
        key: 'type',
        label: i18n.t('membership_request.type._')
    },
    {
        key: 'status',
        label: i18n.t('membership_request.status')
    },
]

export default fields